import React from 'react';

import { DemoPrivacyModeContext } from 'src/providers/DemoPrivacyModeProvider/DemoPrivacyModeContext';

export const useDemoPrivacyMode = () => {
  return React.use(DemoPrivacyModeContext);
};
